import { AntPopover, Icons, Progress, Text, defaultTheme } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { ACommentsTrack } from 'views/components/Comments/AComments'
import { CommentItemProps } from 'views/components/Comments/CommentsItem'
import { CommentContainer, CommentDate, CommentHeader, CommentText } from './styled'
import { AButton } from '../Analytics'
import { useState } from 'react'
import { CommentPopoverContent } from './CommentPopoverContent'
import { CardButtonWrapper } from 'views/styled/ItemCardStyles'

const HeaderWrapper = styled(CommentHeader)`
  display: flex;
  column-gap: 4px;
`

const AuthorInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`

const AuthorInfo = styled.div`
  display: flex;
  @media (max-width: ${defaultTheme.queries.mobile}) {
    flex-direction: column;
  }
`

const StarIcon = styled(Icons.IconStar)`
  & > path {
    fill: ${({ theme }) => theme.color.accentNotify600};
  }
`
const Date = styled(CommentDate)`
  @media (max-width: ${defaultTheme.queries.mobile}) {
    margin-left: 0px;
  }
`
export const PinnedCommentItem = ({
  comment,
  setComment,
  setIsEdit,
  setCommentId,
  unpinComment,
  unpinProgress,
  onATrack,
}: CommentItemProps & { onATrack: ACommentsTrack; unpinComment: (id: string) => void; unpinProgress: Progress }) => {
  const { t } = useTranslation('comments')
  const formatDate = useFormatDate()
  const [popoverVisible, setPopoverVisible] = useState(false)
  const onClickEdit = () => {
    onATrack('click|edit', comment.comment)
    setIsEdit?.(true)
    setComment?.(comment.comment)
    setCommentId?.(comment.id)
  }

  const editInfo = `${t('edited')}: ${comment.last_modified_author} ${formatDate(comment.modified, { withTime: true })}`

  return (
    <CommentContainer>
      <Card.Container disableShadow padding="compact" intent="description">
        {/*!isEdit && <Card.EditButton size="small" onClick={onClickEdit} />*/}
        <CardButtonWrapper>
          <AntPopover
            content={
              <CommentPopoverContent
                setPopoverVisible={setPopoverVisible}
                onClickEdit={onClickEdit}
                onUnpin={() => unpinComment(comment.id)}
                unpinProgress={unpinProgress}
              />
            }
            placement="bottomRight"
            trigger="click"
            open={popoverVisible}
            onOpenChange={() => setPopoverVisible(!popoverVisible)}
          >
            <AButton
              id="commentsActions"
              color="secondary"
              background="none"
              Icon={Icons.IconMoreHoriz}
              onClick={(e) => e.stopPropagation()}
            />
          </AntPopover>
        </CardButtonWrapper>

        <HeaderWrapper>
          <StarIcon />
          <AuthorInfoWrapper>
            <AuthorInfo>
              <Text as="span" typography="accentMedium">
                {comment.author}
              </Text>
              <Date>{formatDate(comment.created, { withTime: true })}</Date>
            </AuthorInfo>
            {comment.last_modified_author && (
              <Text color="accent" typography="bodySmall">
                {editInfo}
              </Text>
            )}
          </AuthorInfoWrapper>
        </HeaderWrapper>

        <CommentText>{comment.comment}</CommentText>
      </Card.Container>
    </CommentContainer>
  )
}
